import React from "react";
import styled from "styled-components";
import { Images, SVG } from "../../config";
interface ContainerProps {
  maxWidth?:string | number;
}
const LogoContainer = styled.div<ContainerProps>(({ maxWidth = 154,  }) => {
  return {
    width: "100%",
    height: "auto",
    flexShrink: 0,
    maxWidth: maxWidth,
  };
});

type DefaultLogoProps = {
  white?: boolean;
  maxWidth?: string | number;
};

function DefaultLogo({ white, maxWidth }: DefaultLogoProps) {
  return (
    <LogoContainer maxWidth={maxWidth}>
      {white ? (
        <img
          src={Images.LogoWhite}
          style={{
            width: maxWidth ? maxWidth : "100%",
            height: "100%",
          }}
        />
      ) : (
        <img
          src={Images.LogoWhite}
          style={{
            width: maxWidth ? maxWidth : "100%",
            height: "100%",
          }}
        />
      )}
    </LogoContainer>
  );
}

export default DefaultLogo;
